import { GetRecoilValue, selector } from 'recoil';

import { END_CUSTOMER } from 'connectors/userTypes';
import { calculateQuoteValidationState } from 'utils/helpers/quoteValidation';

import {
  authenticationState,
  currentQuoteState,
  selectedAccountState,
  currentQuoteValidationState,
  loggedInAccountState,
} from './atoms';
import { CurrentQuoteState } from 'types';
import { CURRENT_ACCOUNT_LOCAL_STORAGE, CURRENT_QUOTE_LOCAL_STORAGE } from 'utils/constants';

// Defines the home url based on the user type
export const homeUrlSelector = selector({
  key: 'homeUrlSelector',
  get: ({ get }) => {
    const { userType } = get(authenticationState);

    return userType === END_CUSTOMER ? '/quote-manager/quotes' : '/accounts';
  },
});

export const storageCurrentQuoteSelector = selector({
  key: 'currentQuoteSelector',
  get: ({ get }: { get: GetRecoilValue }) => get(currentQuoteState),
  set: ({ get, set }, newQuoteState) => {
    const quoteValidation = get(currentQuoteValidationState);
    const account = get(selectedAccountState);
    const authenticationInformation = get(authenticationState);
    const loggedInAccount = get(loggedInAccountState);

    const quoteData = newQuoteState as CurrentQuoteState;

    const validationState = calculateQuoteValidationState({
      quoteData,
      quoteValidation,
      account,
      authenticationInformation,
      loggedInAccount,
    });

    set(currentQuoteValidationState, validationState);

    // Set quote state on local storage and Recoil
    localStorage.setItem(CURRENT_QUOTE_LOCAL_STORAGE, JSON.stringify(newQuoteState));
    set(currentQuoteState, newQuoteState);
  },
});

export const storageSelectedAccountSelector = selector({
  key: 'selectedAccountSelector',
  get: ({ get }) => get(selectedAccountState),
  set: ({ set }, newValue) => {
    localStorage.setItem(CURRENT_ACCOUNT_LOCAL_STORAGE, JSON.stringify(newValue));
    set(selectedAccountState, newValue);
  },
});
